export function PauseIcon() {
  return (
    <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="22" cy="22" r="22" fill="white" />
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18 16H20C20.5523 16 21 16.4477 21 17V27C21 27.5523 20.5523 28 20 28H18C17.4477 28 17 27.5523 17 27V17C17 16.4477 17.4477 16 18 16ZM24 16H26C26.5523 16 27 16.4477 27 17V27C27 27.5523 26.5523 28 26 28H24C23.4477 28 23 27.5523 23 27V17C23 16.4477 23.4477 16 24 16Z"
          fill="black"
        />
      </g>
    </svg>
  );
}
export default PauseIcon;
